<template>
  <div class="h-100">
    <div
      v-if="
        traineesList.length ||
        trainees.length ||
        (filterDataItems && filterDataItems.length) ||
        q ||
        !isLoaded
      "
      v-cloak
    >
      <div
        v-cloak
        v-if="
          traineesList.length ||
          trainees.length ||
          (filterDataItems && filterDataItems.length) || q 
        "
      >
        <div class="row align-items-center mb-3" v-if="clientType != 2">
          <div class="col-md-12 h-100">
            <div class="text-center">
              <div v-if="monitor.visible" class="alert" :class="monitor.type">
                {{ monitor.message }}
              </div>
            </div>
            <form action="" @submit.prevent class="h-100">
              <ValidationObserver ref="form">
                <div class="row d-flex justify-content-between">
                  <div class="col-6 col-sm-4">
                    <div>
                      <validation-provider
                        name="recherche"
                        rules="min:2"
                        v-slot="{ errors }"
                      >
                        <input
                          type="text"
                          name="search"
                          v-model.trim="q"
                          class="form-control form-control_search"
                          :placeholder="$t('buttons.searchByName')"
                          :class="{ 'is-invalid': errors.length }"
                          v-lazy-input:debounce="700"
                          @input="search()"
                        />
                        <span class="text-danger small">{{ errors[0] }}</span>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="col-md-4 d-flex justify-content-end">
                    <button
                      class="btn btn-icon ml-4"
                      :class="
                        filterDataItems && filterDataItems.length
                          ? 'btn-dark'
                          : 'btn-filter '
                      "
                      type="button"
                      @click.prevent.stop="showFilterModal"
                    >
                      <span
                        :class="
                          filterDataItems && filterDataItems.length
                            ? 'icon icon-filter-light'
                            : 'icon icon-filter'
                        "
                      />
                      <span class="">
                        {{ $t('filter') }}
                      </span>
                    </button>
                  </div>
                </div>
              </ValidationObserver>
            </form>
          </div>
        </div>
        <div class="row mb-3" v-if="clientType != 2">
          <div class="col-md-12">
            <div class="mb-2">
              <button
                class="btn btn-icon btn-toggle mb-2"
                :class="isFiltrSelected ? 'btn-white' : 'btn-filter-toggle'"
                @click.stop.prevent="toggleSelectedFiltered"
                :disabled="isAllTrainnesSelected || !isFiltred"
              >
                <span
                  class="icon"
                  :class="isFiltrSelected ? 'icon-check' : 'icon-check-gray'"
                />
                {{ $t('selectFiltered') }} ({{ filtredTrainee.length }})
              </button>
              <button
                class="btn btn-icon btn-toggle mb-2"
                :class="
                  isAllTrainnesSelected ? 'btn-white' : 'btn-filter-toggle'
                "
                :disabled="pagination.total_pages == 1"
                @click.stop.prevent="toggleSelectAllTrainees"
              >
                <span
                  :class="
                    isAllTrainnesSelected
                      ? 'icon icon-trainee'
                      : 'icon icon-trainee-gray'
                  "
                />
                {{
                  $tc(
                    isAllTrainnesSelected ? 'deselectAll' : 'selectAll',
                    pagination.total
                  )
                }}
              </button>
            </div>
            <div>
              <button
                class="btn btn-primary btn-icon mb-2"
                @click.stop.prevent="showRegistrationModal"
                :disabled="!isSelected || clientType == 5 || !canRegister"
              >
                <span class="icon icon-plus" />
                {{ $tc('registerToSession', isSelected) }}
              </button>
              <button
                class="btn btn-primary btn-icon mb-2"
                @click.stop.prevent="registrationsCompliances"
                v-if="
                  company && company.id && establishment && establishment.id
                "
                :disabled="
                  !compliancesList.length ||
                  (!isSelected && !compliancesList.length)
                "
              >
                <span class="icon icon-plus" />
                {{ $tc('registerToCompliance', isSelected) }}
              </button>
              <button
                @click.stop.prevent="exportTraines"
                v-if="
                  company && company.id && establishment && establishment.id
                "
                :class="{ disabled: !isSelected }"
                class="btn btn-primary btn-icon mb-2"
              >
                <span class="icon icon-file_white"></span>
                {{ $tc('export', isSelected) }}
              </button>
            </div>
          </div>
        </div>
        <div class="row mb-3" v-if="filterDataItems && filterDataItems.length">
          <div class="col-12">
            <div
              class="d-flex justify-content-between align-items-center legend"
            >
              <div class="">
                {{
                  $tc('filterCount', pagination.total, {
                    count: pagination.total,
                  })
                }}
              </div>
              <div class="mt-1">
                <button
                  class="btn btn-reset-filter btn-icon px-0"
                  @click="resetFilter"
                >
                  {{ $t('resetFilter') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isLoaded" class="row">
        <div class="col-md-12" v-if="clientType != 2">
          <div>
            <div class="">
              <div
                v-cloak
                v-if="!traineesList.length"
                class="box-block text-center"
              >
                <div class="alert alert-primary mb-0">
                  {{ $t('team.emptyTraineeList') }}
                </div>
              </div>
              <div v-else v-cloak class="dates dates_users">
                <table
                  class="table profile-table table-responsive-lg overflow-y-xs"
                >
                  <th></th>
                  <th>{{ $t('id') }}</th>
                  <th>
                    <div
                      class="cell-item sort-icon"
                      @click="toggleOrder('-lastname')"
                    >
                      <span
                        :class="
                          orderDirection == 'lastname' ||
                          orderDirection == '-lastname'
                            ? 'text-primary'
                            : ''
                        "
                        >{{ $t('form.lastname') }}</span
                      >
                      <span
                        :class="firstnameDirectionClass"
                        class="pl-1"
                      ></span>
                    </div>
                  </th>

                  <th>
                    <div
                      class="cell-item sort-icon"
                      @click="toggleOrder('-function')"
                    >
                      <span
                        :class="
                          orderDirection == 'function' ||
                          orderDirection == '-function'
                            ? 'text-primary'
                            : ''
                        "
                        >{{ $t('form.function') }}</span
                      >
                      <span :class="functionDirectionClass" class="pl-1"></span>
                    </div>
                  </th>
                  <th class="service-th">
                    {{ $t('service') }}
                  </th>
                  <th>{{ $t('form.local') }}</th>
                  <th>{{ $t('establishment') }}</th>
                  <th v-if="checkEditable">{{ $t('actions') }}</th>
                  <tbody class="box-block">
                    <team-row
                      v-for="(trainee, index) in traineesList"
                      :key="trainee.id"
                      :index="index"
                      :trainee="trainee"
                      :user="user"
                    ></team-row>
                  </tbody>
                </table>
                <div>
                  <div class="row mt-3 mb-3" v-if="pagination.total_pages > 1">
                    <div class="col-sm-12 d-flex justify-content-between">
                      <div class="">
                        <button
                          class="btn btn-filter btn-icon"
                          @click="previousPage()"
                        >
                          <span class="icon icon-arrow-left" />
                          {{ $t('previous') }}
                        </button>
                      </div>
                      <div>
                        {{ $t('pagination', [page, pagination.total_pages]) }}
                      </div>
                      <div class="">
                        <button
                          class="btn btn-filter btn-icon"
                          @click="nextPage()"
                        >
                          {{ $t('next') }}
                          <span class="icon icon-arrow-right" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div>
            <div v-if="clientType === 2">
              <h4>{{ $t('team.membersTitle') }}</h4>
              <div class="box-block text-center">
                <div v-cloak v-if="!trainees.length">
                  <div class="alert alert-primary">
                    {{ $t('team.emptyTraineeList') }}
                  </div>
                </div>
                <div v-else v-cloak class="dates dates_users">
                  <div
                    is="PersonalClientRow"
                    v-for="(trainee, index) in trainees"
                    :key="trainee.id"
                    :index="index"
                    :trainee="trainee"
                    :user="user"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-else>
        <div class="col-md-12">
          <div
            class="d-flex justify-content-center align-items-center"
            style="min-height: 200px"
          >
            <div class="d-flex justify-content-center align-items-center">
              <div class="spinner-border" role="status">
                <span class="sr-only"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FilterModal />
      <confirmation-modal></confirmation-modal>
      <trainee-settings-modal></trainee-settings-modal>
      <registration-trainee-modal></registration-trainee-modal>
    </div>
    <div v-else-if="isLoaded" v-cloak class="row">
      <div class="col-md-12">
        <div v-cloak class="box-block text-center">
          <div class="alert alert-primary mb-0">
            {{ $t('team.emptyTraineeList') }}
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div v-if="[2, 4, 6].includes(clientType)" class="col-md-12">
        <TraineeForm
          v-if="checkEditable"
          :title="$t('team.addNewTraineeTitle')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ConfirmationModal from '@/js/components/modals/ConfirmationModal.vue'
import FilterModal from '@/js/components/Profile/my-team/modals/FilterModal.vue'
import TeamRow from './TeamRow.vue'
import PersonalClientRow from './PersonalClientRow.vue'
import TraineeSettingsModal from '@/js/components/modals/TraineeSettingsModal.vue'
import RegistrationTraineeModal from '@/js/components/Profile/my-team/modals/RegistrationTraineeModal.vue'
import { mapFields } from 'vuex-map-fields'
import Treeselect from '@riophae/vue-treeselect'
import TraineeForm from './TraineeForm.vue'

export default {
  name: 'MyTeam',
  components: {
    TraineeForm,
    ConfirmationModal,
    FilterModal,
    TeamRow,
    TraineeSettingsModal,
    PersonalClientRow,
    RegistrationTraineeModal,
    Treeselect,
  },
  data() {
    return {
      page: 1,
      q: '',
      lastTrimedQuery: '',
      filterDataItems: [],
      traineesList: [],
      isFiltred: false,
      isLoaded: false,
      isCompliance: false,
      filterData: {},
      monitor: {
        visible: false,
        message: '',
        type: 'text-warning',
      },
    }
  },
  computed: {
    ...mapFields(['user', 'establishment', 'company']),
    ...mapFields([
      'trainees.trainees',
      'trainees.selectedTrainees',
      'trainees.filtredTrainee',
      'trainees.pagination',
      'trainees.limit',
      'trainees.isFiltrSelected',
      'trainees.isAllTrainnesSelected',
      'trainees.compliancesList',
      'trainees.orderDirection',
      'trainees.orderBy',
    ]),

    clientType() {
      return this.$lodash.get(this.user, 'clientType', false)
    },
    isSelected() {
      if (this.isAllTrainnesSelected) {
        return this.pagination.total
      } else return this.selectedTrainees.length
    },
    toRegiterCount() {
      let nbr = this.selectedTrainees.length
      if (this.isFiltrSelected) {
        nbr = this.filtredTrainee.length
      } else if (this.isAllTrainnesSelected) {
        nbr = this.pagination.total
      } else {
        nbr = this.selectedTrainees.length
      }
      return nbr
    },
    isAllFiltredSelected() {
      if (this.selectedTrainees.length == this.filtredTrainee.length) {
        this.isFiltrSelected = false
        return true
      } else return false
    },
    checkEditable() {
      return Boolean(
        this.clientType === 2 ||
          ([4, 6].includes(this.clientType) &&
            this.$lodash.get(this.establishment, 'id', false))
      )
    },
    firstnameDirectionClass() {
      if (this.orderDirection == '-lastname') {
        return 'icon icon-sort-down'
      } else return 'icon icon-sort-up'
    },
    functionDirectionClass() {
      if (this.orderDirection == '-function') {
        return 'icon icon-sort-down'
      } else return 'icon icon-sort-up'
    },
    canRegister() {
      const permissions = this.user?.permissions ?? []
      const establishmentPermission = permissions.filter(
        (perm) => perm?.establishment?.id == this.establishment?.id
      )
      if (establishmentPermission && establishmentPermission.length) {
        return establishmentPermission[0].establishment?.register
      } else return false
    },
  },
  watch: {
    page: (val) => {
      if (val < 1) {
        this.page = 1
      }
    },
    orderDirection: {
      handler(val) {
        if (val) {
          let qString = null
          if (this.q) {
            let qArray = this.q.split(' ')
            let qFiltred = qArray.filter((word) => word.length > 2)
            qString = qFiltred.join(' ')
            if (qString.length < 2) {
              qString = ''
            }
          }
          let a = {
            ...this.$route.query,
            ...{
              page: this.$route.query.page || 1,
              limit: this.$route.query.limit || this.limit,
              sort: val,
              q: qString,
              ...this.filterData,
            },
          }
          this.getTrainees(a)
        }
      },
    },
    $route: {
      handler(to, from) {
        if (this.$lodash.get(this.$route, 'query', false)) {
          let qString = null
          if (this.q) {
            let qArray = this.q.split(' ')
            let qFiltred = qArray.filter((word) => word.length > 2)
            qString = qFiltred.join(' ')
            if (qString.length < 2) {
              qString = ''
            }
          }
          let a = {
            ...this.$route.query,
            ...{
              page: this.$route.query.page || 1,
              limit: this.$route.query.limit || this.limit,
              sort: this.orderDirection,
              q: qString,
              ...this.filterData,
            },
          }
          this.getTrainees(a)
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.isFiltrSelected = false
    this.isFiltred = false
    this.filtredTrainee = []
    this.selectedTrainees = []
    let params = {
      companyId: this.company.id,
    }

    this.getCompliances(params)
    this.$bus.$on('delete-trainee-confirmation.confirmed', (trainee) => {
      this.$store
        .dispatch('deleteTrainee', trainee.id)
        .then((response) => {
          if (response.status === 200) {
            let data = {}
            data.visible = true
            data.type = 'text-success'
            this.$bus.$emit('success-message', data)
            let index = this.traineesList.findIndex((i) => {
              return i.id === trainee.id
            })
            console.log('index ', index)
            if (index != -1) {
              this.traineesList.splice(index, 1)
            }
          }
        })
        .catch((error) => {
          this.monitor.type = 'text-warning'
          this.monitor.message = this.$t('errors.serverError')
          this.monitor.visible = true
          console.log(error)
          setTimeout(() => {
            this.monitorHide()
          }, 1500)
        })
    })
    this.$bus.$on('trainees-updated', (trainee) => {
      let qArray = this.q.split(' ')
      let qFiltred = qArray.filter((word) => word.length > 2)
      let qString = qFiltred.join(' ')
      if (qString.length < 2) {
        qString = ''
      }
      let a = {
        ...this.$route.query,
        ...{
          page: 1,
          limit: this.$route.query.limit || this.limit,
          sort: this.orderDirection || '-firstname',
          q: qString,
          action: qString ? 'search' : '',
          ...this.filterData,
        },
      }
      this.page = 1
      this.filtredTrainee = []
      this.getTrainees(a)
      this.isFiltred = false
      this.$store.dispatch('getAccountInformations')
    })
    this.$bus.$on('trainees-added', (id) => {
      this.$router.push({ path: `/trainee/${id}` }).catch((err) => {
        console.log(err)
      })
    })
    this.$bus.$on('filter-trainees', (data) => {
      this.filterDataItems = data.filterDataItems
      this.filter(data.data).then(() => {
        this.filterData = data.data
        this.$bus.$emit('hide-filter-trainee-modal')
      })
    })
  },
  beforeMount() {
    this.$bus.$off('delete-trainee-confirmation.confirmed')
    this.$bus.$off('trainees-updated')
    this.$bus.$off('trainees-added')
    this.$bus.$off('filter-trainees')
  },
  methods: {
    resetFilter() {
      this.$bus.$emit('reset-filter-my-team')
      this.q = ''
      this.lastTrimedQuery = ''
      this.orderDirection = 'firstname'
      this.filterData = {
        language: null,
        service: null,
        establishment: null,
        function: null,
      }
      let a = {
        ...this.$route.query,
        ...{
          page: 1,
          limit: this.limit,
          sort: this.orderDirection,
        },
        ...this.filterData,
      }
      this.page = 1
      // this.search()
      this.$router.push({ name: 'MyTeam', query: a }).catch((error) => {})
    },
    toggleOrder(orderBy) {
      this.orderBy = orderBy
      if (this.orderDirection == orderBy) {
        this.orderDirection = orderBy.substring(1)
      } else {
        this.orderDirection = orderBy
      }
    },
    toggleTriFunction() {
      if (this.orderDirection == 'habilitation') {
        this.orderDirection = '-habilitation'
      } else {
        this.orderDirection = 'habilitation'
      }
    },
    exportTraines() {
      let data = {}
      if (this.isAllTrainnesSelected) {
        data.ids = ['All']
        data.establishmentId = this.establishment.id
        if (this.isFiltred) {
          data.language = this.filterData?.language ?? null
          data.service = this.filterData?.service ?? null
          data.establishment = this.filterData?.establishment ?? null
          data.function = this.filterData?.function ?? null
        }
      } else {
        data.ids = this.selectedTrainees
        data.establishmentId = this.establishment.id
      }

      this.$store.dispatch('trainees/exportTrainee', data).then((response) => {
        var data = new Blob([response.data], {
          type: response.headers['content-type'],
        })
        let a = document.createElement('a')
        a.href = URL.createObjectURL(data)
        a.download = 'trainees_export.xlsx'
        a.click()
      })
    },
    registrationsCompliances() {
      let data = {}
      if (this.isAllTrainnesSelected) {
        data.trainees = ['All']
        data.establishmentId = this.establishment.id
      } else {
        data.trainees = this.selectedTrainees
        data.establishmentId = this.establishment.id
      }

      this.$store
        .dispatch('trainees/registerCompliance', data)
        .then((response) => {
          if (response.status === 200) {
            this.monitor.type = 'text-success'
            this.monitor.message = this.$tc('registerToCompliance')
            this.monitor.visible = true
            window.scrollTo(0, 0)
            setTimeout(() => {
              this.monitor.type = ''
              this.monitor.message = ''
              this.monitor.visible = false
            }, 5000)
          }
        })
        .catch((error) => {
          this.monitor.type = 'alert-danger'
          if (error.response.status == 404) {
            this.monitor.message = this.$t('errors.toClientNotFound')
          } else if (error.response.status == 406) {
            this.monitor.message = this.$t('errors.complianceNotFound')
          } else if (
            error.response.status == 422 ||
            error.response.status == 423
          ) {
            this.monitor.message = this.$t('errors.noResultinTraineeLanguage')
          } else {
            this.monitor.message = this.$t('errors.serverError')
          }
          this.monitor.visible = true
          console.log(error)
          console.log('error.response ', error.response)
          setTimeout(() => {
            this.monitorHide()
          }, 5000)
        })
    },
    showFilterModal() {
      this.$bus.$emit('filter-trainee-modal.show')
    },
    showRegistrationModal() {
      let data = {}
      if (this.isFiltrSelected || this.isFiltred) {
        data.language = this.filterData?.language ?? null
        data.service = this.filterData?.service ?? null
        data.establishment = this.filterData?.establishment ?? null
        data.function = this.filterData?.function ?? null
      }
      if (this.isAllTrainnesSelected) {
        data.trainees = []
        data.total = this.pagination.total
        data.isAllSelected = true
      } else {
        data.trainees = this.selectedTrainees
        data.total = this.selectedTrainees.length
        data.isAllSelected = false
      }
      this.$bus.$emit('trainee-registration-modal.show', data)
    },
    nextPage() {
      if (
        this.pagination.total_pages > 1 &&
        this.page < this.pagination.total_pages
      ) {
        this.page++
        let qArray = this.q.split(' ')
        let qFiltred = qArray.filter((word) => word.length > 2)
        let qString = qFiltred.join(' ')
        if (qString.length < 2) {
          qString = ''
        }
        let a = {
          ...this.$route.query,
          ...{
            action: qString ? 'search' : '',
            page: this.page,
            limit: this.limit,
            sort: this.orderDirection,
            q: qString,
            ...this.filterData,
          },
        }
        this.$router.push({ name: 'MyTeam', query: a }).catch((error) => {})
      }
    },
    previousPage() {
      if (this.pagination.total_pages > 1 && this.page > 1) {
        let qArray = this.q.split(' ')
        let qFiltred = qArray.filter((word) => word.length > 2)
        let qString = qFiltred.join(' ')
        if (qString.length < 2) {
          qString = ''
        }
        this.page--
        let a = {
          ...this.$route.query,
          ...{
            action: qString ? 'search' : '',
            page: this.page,
            limit: this.limit,
            sort: this.orderDirection,
            q: qString,
            ...this.filterData,
          },
        }
        this.$router.push({ name: 'MyTeam', query: a }).catch((error) => {})
      }
    },
    filter(params) {
      this.isFiltred = true
      // this.selectedTrainees = []
      this.isLoaded = false
      let payload = {}
      this.page = 1
      if (this.q) {
        let qArray = this.q.split(' ')
        let qFiltred = qArray.filter((word) => word.length > 2)
        let qString = qFiltred.join(' ')
        if (qString.length < 2) {
          qString = ''
        }
        payload = {
          params: {
            action: 'search',
            q: qString,
            page: 1,
            limit: this.limit,
            sort: this.orderDirection,
            ...params,
          },
          id: this.user.id,
        }
      } else {
        payload = {
          params: {
            ...params,
            page: 1,
            limit: this.limit,
            sort: this.orderDirection,
          },
        }
      }
      return this.$store
        .dispatch('trainees/searchTrainees', payload)
        .then(() => {
          this.traineesList = this.filtredTrainee
        })
        .finally(() => {
          this.isLoaded = true
          //this.isFiltrSelected = true;
        })
    },
    search() {
      if (this.q != '') {
        let qArray = this.q.split(' ')
        let qFiltred = qArray.filter((word) => word.length > 2)
        let qString = qFiltred.join(' ')
        if (this.lastTrimedQuery == qString.trim()) {
          return
        }
        if (qString.length < 2) return
        let payload = {
          params: {
            action: 'search',
            q: qString,
            ...this.filterData,
            page: 1,
            limit: this.limit,
            sort: this.orderDirection,
          },
          id: this.user.id,
        }
        this.lastTrimedQuery = qString.trim()
        this.page = 1
        this.$store
          .dispatch('trainees/searchTrainees', payload)
          .then((response) => {
            this.traineesList = this.filtredTrainee
          })
          .finally(() => {
            this.isLoaded = true
            //this.isFiltrSelected = true;
          })
      } else {
        let a = {
          ...this.$route.query,
          ...{
            page: 1,
            limit: this.limit,
            sort: this.orderDirection,
            ...this.filterData,
          },
        }
        this.page = 1
        this.lastTrimedQuery = ''
        this.filtredTrainee = []
        this.getTrainees(a)
        this.isFiltred = false
      }
    },
    getTrainees(params) {
      this.isLoaded = false
      this.$store
        .dispatch('trainees/getTrainees', params)
        .then(() => {
          this.traineesList = this.trainees
        })
        .finally(() => {
          this.isFiltrSelected = false
          this.selectedTrainees = []

          if (
            this.isAllTrainnesSelected &&
            this.filterDataItems &&
            this.filterDataItems.length
          ) {
            this.$lodash.forEach(this.traineesList, (trainee) => {
              this.selectedTrainees.push(trainee.id)
            })
          } else if (this.isAllTrainnesSelected) {
            this.$lodash.forEach(this.trainees, (trainee) => {
              this.selectedTrainees.push(trainee.id)
            })
          }
          this.isLoaded = true
        })
    },
    getCompliances(params) {
      return this.$store.dispatch('trainees/getCompliances', params)
    },
    toggleSelectedFiltered() {
      this.isFiltrSelected = !this.isFiltrSelected
      this.isAllTrainnesSelected = false
      this.selectedTrainees = []
      if (this.isFiltrSelected) {
        this.$lodash.forEach(this.filtredTrainee, (trainee) => {
          this.selectedTrainees.push(trainee.id)
        })
      }
    },
    toggleSelectAllTrainees() {
      this.isAllTrainnesSelected = !this.isAllTrainnesSelected
      this.isFiltrSelected = false
      this.selectedTrainees = []
      if (
        this.isAllTrainnesSelected &&
        this.filterDataItems &&
        this.filterDataItems.length
      ) {
        this.$lodash.forEach(this.traineesList, (trainee) => {
          this.selectedTrainees.push(trainee.id)
        })
      } else if (this.isAllTrainnesSelected) {
        this.$lodash.forEach(this.trainees, (trainee) => {
          this.selectedTrainees.push(trainee.id)
        })
      }
    },
    monitorHide() {
      this.monitor.type = ''
      this.monitor.message = ''
      this.monitor.visible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.service-th {
  &:hover {
    cursor: pointer;
  }
}
.sort-icon:hover {
  cursor: pointer;
}
.legend {
  text-transform: none !important;
  font-size: 1rem;
}
</style>
